module.exports = __webpack_public_path__ + "app/principal/principal-check-config-all-head-_HSApRY6.html";